export const NotificationClickAction = {
	SelectPremiumNameplate: 1,
	ViewTrophy: 2,
	OpenProfile: 3,
};
